/**
 * Дефолтные тексты формы, которые видит человек (респондент или владелец).
 *
 * Эти значения попадают в схему формы при создании и отображаются «как есть»:
 * рендерер берёт `schema.settings.successMessage`/`submitText` из схемы, а в
 * i18n ключей для сообщений лимитов/пароля/дубликатов нет вовсе. Поэтому
 * держим их на русском в одном модуле (решение по задаче t_d176ce73).
 * Формулировки по возможности совпадают с messages/ru.json.
 */
export const formCopy = {
	/** Название формы, если владелец его не задал. */
	untitledForm: "Форма без названия",
	/** Первый шаг многошаговой формы. */
	firstStepTitle: "Шаг 1",
	firstStepDescription: "Первый шаг вашей формы",
	/** Кнопка отправки и сообщение после успешной отправки. */
	submitText: "Отправить",
	successMessage: "Спасибо за вашу отправку!",
	rateLimitMessage: "Подождите перед повторной отправкой.",
	profanityMessage: "Пожалуйста, соблюдайте уважительный тон.",
	responseLimitMessage: "Эта форма больше не принимает ответы.",
	passwordMessage:
		"Эта форма защищена паролем. Введите пароль, чтобы продолжить.",
	duplicateMessage:
		"Вы уже отправили эту форму. Каждый пользователь может отправить только один раз.",
	botMessage: "Обнаружен бот. Доступ запрещён.",
} as const;
